<!--
 * @Author: daidongyu daidongyu@cnuri.cn
 * @Date: 2024-02-22 16:16:49
 * @LastEditors: daidongyu daidongyu@cnuri.cn
 * @LastEditTime: 2024-02-23 16:49:47
 * @FilePath: /my-activation/src/weixinBind/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="app">
    <div class="registerBox">
      <div class="rightBox">
        <!-- <div class="Tips" style="margin-bottom:4px;">必填信息</div> -->
        <div class="Requirement">
          <div class="letRe fl">姓名</div>
          <input
            class="rigRe fr"
            type="text"
            placeholder="请输入姓名"
            v-model="name"
          />
        </div>
        <div class="Requirement">
          <div class="letRe fl">电话</div>
          <input
            class="rigRe fr"
            type="number"
            placeholder="请输入电话号码"
            pattern="[0-9]*"
            v-model="tel"
          />
        </div>

        <div
          class="Determine"
          :class="disabled === true ? 'dis' : ''"
          @click="disabled === true ? '' : clickApply()"
        >
          激活
        </div>
      </div>
    </div>
    <loading v-if="load"></loading>
    <div class="toast" v-show="toast">{{ toastText }}</div>
  </div>
</template>
<script>
export default {
  name: 'Register',
  data() {
    return {
      name: '',
      tel: '',
      idx: 60,
      itemFlase: true,
      toast: false,
      toastText: '',
      load: false,
      disabled: false,
    }
  },
  mounted() {
    localStorage.setItem('companyID', this.$route.query.companyID)
  },
  methods: {
    clickApply() {
      // companyID  termID openid cardCode  cardID

      if (!this.name || !this.tel) {
        this.toast = true
        this.toastText = '请先填写完整信息'
        setTimeout(() => {
          this.toast = false
        }, 1000)
        return
      }
      this.disabled = true
      this.RequestVIP3(
        `h5/vip/card/user/info/${this.$route.query.openid}`,
        {
          username: this.name,
          tel: this.tel,
          cardCode: this.$route.query.cardCode,
          cardID: this.$route.query.cardID,
          terminalID: this.$route.query.termID,
        },
        (r) => {
          console.log(r, 'rrrrrrrrr')
          this.disabled = false
          this.toast = true
          this.toastText = '激活成功！'
          setTimeout(() => {
            this.toast = false
            wx.closeWindow()
            // window.location.replace('about:blank')
          }, 2000)
        }
      ),
        (err) => {
          this.disabled = false
          console.log(err, 'rrrreee')
          this.toast = true
          this.toastText = err
          setTimeout(() => {
            this.toast = false
          }, 1000)
        }
    },
  },
}
</script>
<style scoped>
/*! autoprefixer: off */
.app {
  height: 100%;
  width: 100%;
  background: #fff;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.registerBox {
  width: 94%;
  margin-left: 3%;
  background: #fff;
  border-radius: 5px;
  height: 74%;
  padding-top: 10px;
  /* box-shadow: 0px 0px 5px 0px #bdbdbd; */
  position: relative;
}
.rightBox {
  float: right;
  width: 94%;
  height: 100%;
  margin-top: 10px;
}
.rightBox > div {
  border-bottom: 1px solid #e0e0e0;
}
.Tips {
  font-size: 12px;
  color: #757575;
  height: 20px;
  line-height: 20px;
}
.Requirement {
  height: 35px;
  line-height: 35px;
  font-size: 11px;
  color: #212121;
  position: relative;
}
.letRe {
  width: 22%;
  height: 100%;
}
.rigRe {
  display: block;
  height: 100%;
  width: 75%;
  border: none;
  padding: 9px 14px;
  box-sizing: border-box;
  /* border-bottom: 1px solid #e0e0e0; */
  font-size: 11px;
}
input::-webkit-input-placeholder {
  color: #bdbdbd;
  font-size: 11px;
}
input {
  outline: none;
}
.Tips {
  width: 100%;
  height: 20px;
  margin-top: 10px;
  border: none !important;
  font-size: 8px;
}
.Tips_lo {
  width: 12px;
  height: 12px;
  line-height: 12px;
  text-align: center;
  border-radius: 50%;
  color: #fff;
  background: #46a1ff;
  margin-top: 4px;
  margin-right: 3%;
  font-size: 8px;
}
.Tips_text {
  color: #757575;
  line-height: 20px;
}
.Determine {
  width: 93%;
  height: 32px;
  text-align: center;
  line-height: 32px;
  color: #fff;
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
  border-radius: 4px;
  font-size: 11px;
  text-decoration: none;
  margin-top: 38%;
}
.vcodeSty {
  height: 19px;
  line-height: 19px;
  position: absolute;
  right: 6px;
  top: 6px;
  width: 46px;
  border: 0.5px solid red;
  color: red;
  font-size: 8px;
  border-radius: 2px;
  text-align: center;
}
.vcodeStyFa {
  border: 0.5px solid #bdbdbd;
  color: #bdbdbd;
}
.toast {
  width: 100px;
  /* height: 30px; */
  line-height: 15px;
  padding: 10px;
  border-radius: 5px;
  background: rgb(49, 47, 47);
  opacity: 0.5;
  color: white;
  position: fixed;
  top: 46%;
  left: 30%;
  text-align: center;
  font-size: 10px;
}
.dis {
  background: gray;
}
.returns {
  position: fixed;
  top: 80%;
  left: 0;
}
.gantan {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50px;
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
  color: #fff;
  font-size: 8px;
  text-align: center;
  line-height: 10px;
}
/*! autoprefixer: on */
</style>



// WEBPACK FOOTER //
// src/weixinBind/index.vue